import React, { useEffect, useRef, useState } from 'react'
import "./SectorCriteria.css"
import { ReactComponent as ExpandIcon } from "../../../../assets/icons/arrow-down.svg";
import ToggleButton from '../../../Common/ToggleButton/ToggleButton';
import { getFlagSvg } from '../../../Common/Flag/Flag';


export interface SectorCriteriaItem {
    label: string;
    value: string;
    selected: boolean;
}

export interface SectorCriteriaProps {
    sectors: SectorCriteriaItem[];
    setSectors: (sectors: SectorCriteriaItem[]) => void;
    isHeaderStyle?: boolean;
}

const SectorCriteria = ({ sectors, setSectors, isHeaderStyle = false }: SectorCriteriaProps) => {
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = useState(false);


    useEffect(() => {
        const handleClickOutside = (event: any) => {
            // If the click is outside the dropdown container, close it
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        // Cleanup the event listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
    }, [sectors]);

    const toggleSector = (value: string, selected: boolean) => {
        const index = sectors.findIndex((item) => item.value === value);
        if (index >= 0) {
            const newSectors = [...sectors];
            newSectors[index] = { ...newSectors[index], selected: !selected };
            setSectors(newSectors);
        }
    };

    const isAllSelected = sectors.every((item) => item.selected);
    const isSomeSelected = sectors.some((item) => item.selected);

    const toggleAllMarkets = (selected: boolean) => {
        setSectors(
            sectors.map((item: SectorCriteriaItem) => ({
                ...item,
                selected: !selected,
            }))
        );
    };

    const selectedSectors = sectors.filter(s => s.selected);
    const selectedCount = selectedSectors.length;

    const getHeaderLabel = () => {
        if (selectedCount === 0 || isAllSelected) return 'All sectors';
        if (selectedCount === 1) return selectedSectors[0].label;
        return `Sectors (${selectedCount})`;
    };

    return (
        <div ref={dropdownRef} className={`screener-sector-criteria${isHeaderStyle ? ' screener-sector-criteria--header' : ''}`}>
            <button
                type="button"
                className={`screener-sector-criteria-button ${isOpen ? 'open' : 'closed'}`}
                id="options-menu"
                aria-haspopup="listbox"
                aria-expanded={isOpen}
                onClick={() => setIsOpen(!isOpen)}
            >
                {isHeaderStyle ? (
                    <>
                        <span className="screener-sector-criteria-label">{getHeaderLabel()}</span>
                        <ExpandIcon className={`screener-sector-criteria-expand ${isOpen ? 'open' : 'closed'}`} />
                    </>
                ) : (
                    <>
                        <div className="screener-sector-criteria-button-wrapper">
                            {selectedCount > 0 &&
                                <span className={`screener-sector-criteria-count ${isOpen ? 'open' : 'closed'}`}>
                                    {selectedCount}
                                </span>}
                            <span className={`screener-sector-criteria-label ${isOpen ? 'open' : 'closed'}`}>Sectors</span>
                        </div>
                        <ExpandIcon className={`screener-sector-criteria-expand ${isOpen ? 'open' : 'closed'}`} />
                    </>
                )}
            </button>

            {isOpen && (
                <div className="screener-sector-criteria-list">
                    <div className="screener-sector-criteria-options">
                        <div
                            key={"all"}
                            id={`all`}
                            className={`screener-sector-criteria-option-item-container`}
                            role="option" // Indicates an option in the listbox
                            aria-selected={isAllSelected} // Indicates if the option is selected
                            onClick={() => toggleAllMarkets(isAllSelected)}
                            tabIndex={0} // Make each item focusable for keyboard navigation
                        >
                            <ToggleButton
                                className="screener-sector-criteria-option-item-toggle-button"
                                label={"All sectors"}
                                checked={isAllSelected}
                                indeterminate={isSomeSelected && !isAllSelected}
                                onClick={() => toggleAllMarkets(isAllSelected)}
                            />
                        </div>

                        {sectors.map((option, index) => (
                            <div
                                key={option.value}
                                id={`option-${option.value}`} // Unique ID for each option
                                className={`screener-sector-criteria-option-item-container`}
                                role="option" // Indicates an option in the listbox
                                aria-selected={option.selected} // Indicates if the option is selected
                                onClick={() => toggleSector(option.value, option.selected)}
                                tabIndex={0} // Make each item focusable for keyboard navigation
                            >
                                <ToggleButton
                                    className="screener-sector-criteria-option-item-toggle-button"
                                    label={option.label}
                                    checked={option.selected}
                                    indeterminate={false}
                                    onClick={() => toggleSector(option.value, option.selected)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default SectorCriteria;